/* eslint-disable */

import { grey } from '@material-ui/core/colors';
import Colors from './Support/Theme/Colors/Colors';
import { BORAL_GREEN } from 'Constants/Theme/Theme.constants';

/**
 * Create reusable global styles
 * @param {Styles} styles The result of `createStyles`
 * @returns The global styles
 */
const globalStyles = ({ theme }) => ({
  '@keyframes spinnerAnimation': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  boxShadow0: {
    boxShadow: `0 0 0`,
  },
  banner: {
    padding: theme.spacing(1) * 3,
    transition: `opacity 0.2s,height 0.2s, padding-top 0.2s, padding-bottom 0.2s, margin-top 0.2s`,
    opacity: 1,
    backgroundColor: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    [theme.breakpoints.up(`sm`)]: {
      position: `fixed`,
      borderBottom: 0,
      bottom: theme.spacing(1) * 2,
      zIndex: 9999,
      maxWidth: 440,
      right: theme.spacing(1) * 3,
      boxShadow: `0px 0px 11px #ccc`,
    },
  },
  bannerHidden: {
    height: 0,
    paddingTop: 0,
    paddingBottom: 0,
    opacity: 0,
    overflow: `hidden`,
    border: 0,
  },
  textTransformLowercase: {
    textTransform: `lowercase`,
  },
  textTransformNone: {
    textTransform: `none`,
  },
  textTransformCapitalize: {
    textTransform: `capitalize`,
    opacity: 0.3,
  },
  bannerIcon: {
    fill: theme.palette.background.paper,
    fontSize: theme.spacing(1) * 3,
    backgroundColor: BORAL_GREEN,
  },
  bannerFirstTruck: {
    display: `block`,
    [theme.breakpoints.up(`sm`)]: {
      zIndex: 1250,
    },
  },
  cardContainer: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[1],
    padding: `${theme.spacing(1) * 2}px ${theme.spacing(1) * 3}px`,
    width: `100%`,
    [theme.breakpoints.down(`xs`)]: {
      left: `50%`,
      marginLeft: `-50vw`,
      marginRight: `-50vw`,
      position: `relative`,
      right: `50%`,
      width: `100vw`,
    },
  },
  cursorPointer: {
    cursor: `pointer`,
  },
  displayNone: {
    display: `none`,
  },
  error: {
    backgroundColor: theme.palette.error.dark,
    opacity: 0.9,
  },
  flexGrow1: {
    flexGrow: 1,
  },
  flexGrow2: {
    flexGrow: 2,
  },
  flexWrapNowrap: {
    flexWrap: `nowrap`,
  },
  fontWeight500: {
    fontWeight: 500,
  },
  footer: {
    marginLeft: theme.spacing(1),
  },
  fullHeight: {
    height: `100%`,
  },
  fullScreenOverlay: {
    backgroundColor: `rgba(0,0,0,0.5)`,
    bottom: 0,
    left: 0,
    position: `fixed`,
    right: 0,
    top: 0,
    zIndex: theme.zIndex.modal,
  },
  fullWidth: {
    width: `100%`,
  },
  iconLarge: {
    height: theme.spacing(1) * 6,
    width: theme.spacing(1) * 6,
  },
  iconLeft: {
    marginRight: theme.spacing(1),
  },
  iconMedium: {
    height: theme.spacing(1) * 4,
    width: theme.spacing(1) * 4,
  },
  iconSmall: {
    height: theme.spacing(1) * 3,
    width: theme.spacing(1) * 3,
  },
  listStyleNone: {
    listStyle: `none`,
  },
  displayInline: {
    display: 'inline',
  },
  displayInlineBlock: {
    display: 'inline-block',
  },
  verticalAlignBottom: {
    verticalAlign: 'bottom',
  },
  marginLeftHalfUnit: {
    marginLeft: theme.spacing(1) * 0.5,
  },
  marginLeft1unit: {
    marginLeft: theme.spacing(1) * 1,
  },
  marginTop2unit: {
    marginTop: theme.spacing(1) * 2,
  },
  marginBottom1unit: {
    marginBottom: theme.spacing(1),
  },
  marginBottom2unit: {
    marginBottom: theme.spacing(1) * 2,
  },
  marginBottom3unit: {
    marginBottom: theme.spacing(1) * 3,
  },
  marginTop3unit: {
    marginTop: theme.spacing(1) * 3,
  },
  marginTop1unit: {
    marginTop: theme.spacing(1),
  },
  marginTop0unit: {
    marginTop: 0,
  },
  mutedBackground: {
    backgroundColor: theme.palette.grey[500],
  },
  mutedBorder: {
    borderColor: theme.palette.grey[500],
  },
  mutedText: {
    color: theme.palette.grey[500],
  },
  nakedIcon: {
    marginRight: 12,
    opacity: 0.3,
  },
  noPadding: {
    padding: `0 !important`,
  },
  opacity05: {
    opacity: 0.5,
  },
  opacity06: {
    opacity: 0.6,
  },
  opacity075: {
    opacity: 0.75,
  },
  overflowAuto: {
    overflow: `auto`,
  },
  overflowYhidden: {
    overflowY: `hidden`,
  },
  overflowHidden: {
    overflow: `hidden`,
  },
  sidebarCard: {
    backgroundColor: theme.palette.grey[100],
    overflow: `visible`,
  },
  sidebarCardHeader: {
    paddingBottom: 0,
  },
  sidebarCardHeaderAction: {
    marginBottom: 0,
    marginTop: 0,
  },
  snackbar: {
    zIndex: 99999999,
  },
  snackbarIcon: {
    fontSize: 20,
    marginRight: theme.spacing(1),
  },
  snackbarMessage: {
    alignItems: `center`,
    display: `flex`,
  },
  spaceForFab: {
    marginBottom: theme.spacing(1) * 5,
  },
  spacer: {
    flex: `1 1 auto`,
  },
  marginRight1unit: {
    marginRight: theme.spacing(1),
  },
  alignItemsCenter: {
    alignItems: `center`,
  },
  textAlignCenter: {
    textAlign: `center`,
  },
  textAlignLeft: {
    textAlign: `left`,
  },
  textAlignRight: {
    textAlign: `right`,
  },
  textDecorationUnderline: {
    textDecoration: `underline`,
  },
  textTranformUppercase: {
    textTransform: `uppercase`,
  },
  textOverflowEllipsis: {
    textOverflow: `ellipsis`,
  },
  toolbar: {
    ...theme.mixins.toolbar,
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  warningIcon: {
    fontSize: 20,
    marginRight: 0,
    opacity: 0.3,
  },
  whiteSpaceNowrap: {
    whiteSpace: `nowrap`,
  },
  hyperlink: {
    color: BORAL_GREEN,
  },
  divider: {
    margin: `${theme.spacing(1) * 1.5}px 0 ${theme.spacing(1) * 1.5}px 0`,
  },
  inputLabel: {
    color: theme.typography.caption.color,
    display: `block`,
    fontSize: theme.typography.caption.fontSize,
    lineHeight: theme.typography.caption.lineHeight,
    opacity: 0.5,
  },
  detailsBoxItemBorder: {
    backgroundColor: theme.palette.grey[`300`],
    maxWidth: 1,
    padding: 0,
    height: `100%`,
  },
  overflowScroll: {
    overflow: `scroll`,
  },
  keyLine: {
    height: 1,
    border: 0,
    backgroundColor: grey[300],
  },
  chipRoot: {
    borderColor: theme.boralcolorspalette.zambezi[600],
    backgroundColor: `#fff`,
    '&:hover': {
      backgroundColor: `${theme.boralcolorspalette.zambezi[600]} !important`,
      color: `#fff`,
    },
    '&:hover>*': {
      color: `#fff !important`,
    },
  },
  chipLabel: {
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    display: `block`,
    maxWidth: 182,
  },
  smUp: {
    [theme.breakpoints.down(`sm`)]: {
      display: `none`,
    },
  },
  smDown: {
    [theme.breakpoints.up(`md`)]: {
      display: `none`,
    },
  },
  mdDown: {
    [theme.breakpoints.up(`lg`)]: {
      display: `none`,
    },
  },
  touchedField: {
    backgroundColor: Colors.boralyellow[50],
  },
  editableField: {
    backgroundColor: Colors.boralgreen[50],
  },
  displayFlex: {
    display: 'flex',
  },
  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
  },
  whiteSpacePreLine: {
    whiteSpace: 'pre-line',
  },
  dropdownIcon: {
    fontSize: theme.spacing(1) * 2.8,
    marginRight: theme.spacing(1) * 1.5,
    marginBottom: -theme.spacing(1) / 2,
    opacity: 0.6,
  },
  modalTitleWithDivider: {
    borderBottom: `1px solid ${theme.palette.grey[`300`]}`,
    padding: theme.spacing(1) * 1.1,
    paddingLeft: theme.spacing(1) * 1.4,
    paddingRight: theme.spacing(1) * 3,
  },
  positionRelative: {
    position: 'relative',
  },
  h6LineHeight: {
    lineHeight: 1.2,
  },
  paperAutoHeight: {
    height: 'auto',
  },
  alertContentText: {
    color: 'rgba(0,0,0,0.6)',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
  callBoral: {
    color: Colors.boralgreen[500],
  },
  toolTipContent: {
    lineHeight: '1.7rem' // to align text with icon align to flex-start
  }
});

export default globalStyles;
